import { TextTag as Text } from "../../atoms"
import React, { useEffect, useState } from "react"
import bubbleArt from "../../assets/images/bubble_art.svg"
import taglineBubble from "../../assets/images/section1_bubble.svg"
import EmailSignIn from "../../components/EmailSignIn/EmailSignIn"
import "./SignInPageByEmail.scss"
import { SIGNUP_TEXT, SUB_TAGLINE } from "../../constants/messages"
import { connect } from "react-redux"
import _ from "../../utils/lodashUtils"
import coupleArt from "../../assets/images/couple_art.gif"
import HomePageInfo from "../../components/HomePage/HomePageInfo"
import { CustomModal, Button } from "../../atoms"
import {
  PARTNER_SIGN_UP_MODAL_TITLE,
  CONTINUE_AS_LOGGED_IN_USER,
  PARTNER_SIGN_UP_MODAL_CONTENT,
  LOGOUT_BUTTON,
} from "../../constants/messages"
import { formatPhoneNumber } from "../../utils/helpers"
import { logout, verifyToken } from "../../redux/actionCreators/auth"

const SignInPageByEmail = (props) => {
  const getPhoneNumber = (phoneNumber) => {
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber)

    return formattedPhoneNumber && formattedPhoneNumber.intlCode
      ? `${formattedPhoneNumber.intlCode} ${formattedPhoneNumber.telephoneNumber}`
      : phoneNumber
  }
  const [email, setEmail] = useState("")

  let partnerUserName = decodeURIComponent(
    _.get(props.match.params, "email")
  ).split("=")[1]
  const token = _.get(props.match.params, "token")

  useEffect(() => {
    if (token && partnerUserName) {
      props
        .verifyToken(partnerUserName, token)
        .then((response) => {
          if (response.status === 400) setEmail("")
          else setEmail(partnerUserName)
        })
        .catch((err) => {
          console.error("error while verifying token", err)
        })
    }
  }, [])

  const goToDashboard = () => {
    let userName = _.get(props.user, "username")

    if (_.get(props.user, "signup_method") === "PHONE") {
      userName = getPhoneNumber(userName)
    }

    if (partnerUserName === userName) {
      props.history.push("/dashboard")
    }

    return (
      <CustomModal
        title={PARTNER_SIGN_UP_MODAL_TITLE(userName)}
        visible={true}
        footer={[
          <Button
            type="primary"
            key="save"
            onClick={async () => {
              await props.logout()
            }}
          >
            {LOGOUT_BUTTON}
          </Button>,
          <Button key="cancel" onClick={() => props.history.push("/dashboard")}>
            {CONTINUE_AS_LOGGED_IN_USER}
          </Button>,
        ]}
      >
        {PARTNER_SIGN_UP_MODAL_CONTENT(userName, partnerUserName)}
      </CustomModal>
    )
  }

  return (
    <div id="SignInPagebyEmail">
      <div className="home-background">
        <div className="sideLeft">
          <div className="reverse-content">
            <div className="couple-art-box">
              <img className="couple-art" src={coupleArt} alt="coupleSeat" />
            </div>
            <div className="jomo-text">
              <div className="tagline">
                <img
                  className="bubble-set"
                  src={taglineBubble}
                  alt="Closer together"
                />
                <Text textType="taglineBold">{SIGNUP_TEXT}</Text>
              </div>
              <div className="sub-tagline">
                <Text textType="bodyHeading">{SUB_TAGLINE} </Text>
              </div>
            </div>
          </div>
        </div>
        <div className="sideRight">
          <div className="signupBg">
            {_.get(props, "isAuthenticated") ? (
              goToDashboard()
            ) : (
              <div>
                <EmailSignIn isPartnerSignup={false} email={email} />
              </div>
            )}
          </div>
          <div className="bubble-set-box">
            <img className="bubble-set" src={bubbleArt} alt="bubbles" />
          </div>
        </div>
      </div>
      <HomePageInfo />
    </div>
  )
}

const mapStateToProps = (state) => ({
  partnerInviteData: _.get(state.auth, "partnerInviteData"),
  isAuthenticated: _.get(state.auth, "isAuthenticated"),
  user: _.get(state.auth, "user"),
})

export default connect(mapStateToProps, { logout, verifyToken })(
  SignInPageByEmail
)
